/**
 * R5 草稿恢复条(2026-08-08)。
 *
 * ★两个**明确出口**,没有第三种可能:「用这份」/「丢掉」。
 *   不做「静默自动恢复」——用户刷新页面的意图未必是「接着上次」,可能正是想重来;
 *   自动铺上一稿会让他先删干净才能开始,比空页面更费事。
 * ★上传过照片的那份稿,**明说要重传**:临时 key 过期即死链,我们只记住「你传过」,
 *   不假装形象还在(不拿一个会 404 的引用骗人 —— 详情页那条老账同款)。
 */
import { FileClock } from "lucide-react";

import { Button } from "@/shared/ui/button";

export interface DhDraftBarProps {
  /** 「3 分钟前 / 2 小时前 / 8 月 1 日」。 */
  ageLabel: string;
  /** 上次走的是上传口 → 恢复不回来那张照片,必须明说。 */
  hadUpload: boolean;
  scriptPreview: string;
  onUse: () => void;
  onDiscard: () => void;
}

export function DhDraftBar({
  ageLabel,
  hadUpload,
  scriptPreview,
  onUse,
  onDiscard,
}: DhDraftBarProps) {
  return (
    <div
      data-testid="dh-draft-bar"
      className="flex flex-wrap items-center gap-x-3 gap-y-1.5 rounded-md border border-primary/30 bg-primary/5 px-3 py-2 text-xs"
    >
      <FileClock className="h-3.5 w-3.5 shrink-0 text-primary" />
      <span className="font-medium text-foreground">
        有一份{ageLabel ? `${ageLabel}的` : ""}没出片的稿
      </span>
      <span className="min-w-0 flex-1 truncate text-muted-foreground" title={scriptPreview}>
        「{scriptPreview}」
      </span>
      {/* ★这句必须在恢复**之前**就说,不能等用户点了「用这份」再发现形象是空的 */}
      {hadUpload && (
        <span className="shrink-0 text-amber-600 dark:text-amber-500">
          上次那张照片要重新传(临时链接已过期)
        </span>
      )}
      <span className="flex shrink-0 gap-1.5">
        <Button
          type="button"
          size="sm"
          className="h-7"
          data-testid="dh-draft-use"
          aria-label="恢复这份草稿"
          onClick={onUse}
        >
          用这份
        </Button>
        <Button
          type="button"
          size="sm"
          variant="ghost"
          className="h-7"
          data-testid="dh-draft-discard"
          onClick={onDiscard}
        >
          丢掉
        </Button>
      </span>
    </div>
  );
}
